<template>
  <Form/>
</template>

<script>
import Form from '@/views/tag/Form'
export default {
  name: 'Create',
  components: { Form }
}
</script>
